import api from "./BaseServices";

export interface homePageType {
  id: number;
  user_id: number;
  username: string;
  profile_image_url: string;
  booster_id: number;
  booster_image_url: string;
  booster_name: string;
  booster_description: string;
  updated_at: Date;
  booster_price: number;
  cards: string[];
}

const API_URL = `${process.env.REACT_APP_API_URL}/explore`;

// 👀 Get list of followers for a given user ID
export const getHomePageData = async (
  limit: number,
  offset: number
): Promise<homePageType[]> => {
  const response = await api.get(`${API_URL}/homePage`, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};
